<template>
	<div class="container3">
		<div class="cateloupan_status">
			<span>状态:</span>
			<el-checkbox-group v-model="loupan_status">
				<el-checkbox :label="1">待售</el-checkbox>
				<el-checkbox :label="2">在售</el-checkbox>
				<el-checkbox :label="3">售罄</el-checkbox>
			</el-checkbox-group>
		</div>

		<div class="mapcontainer3">


			<el-bmap vid="landlayout" :zoom="zoom" :center="center" :events="events" class="bmap-demo">
				<el-bmap-label v-for="item in listdata" :position="[item.lng, item.lat]"
				:offset="[-36,-10]"
				 :is-custom="true">
					<div class="labelbox" style="color:#fff;font-size:20px;">
						<div class="labelcontent">
							{{ item.loupanzhuizong || item.locationnum }}
						</div>
						<span class="labeldown" style="color:#000"></span>
					</div>
				</el-bmap-label>
			</el-bmap>
		</div>
		<div class="swipercontainer3">
			<div class="zhibiaotitle">
				地块规划指标
			</div>
			<el-table class="tabledata" :data="listdata" style="margin-bottom: 20px;" row-key="id" border>
				<el-table-column prop="loupanzhuizong" label="项目名称">
				</el-table-column>
				<el-table-column prop="locationnum" label="宗地编号">
				</el-table-column>
				<!-- <el-table-column prop="locationname" label="地块名称">
				</el-table-column> -->
				<el-table-column prop="company" label="开发商">
				</el-table-column>
				<el-table-column prop="tradedate" label="拿地时间">
				</el-table-column>
				<el-table-column prop="floorprice" label="楼面价">
				</el-table-column>
				<el-table-column prop="first_open_time" label="首次开盘时间">
				</el-table-column>
				<el-table-column prop="give_time" label="交房时间">
				</el-table-column>
				<el-table-column prop="acreage" label="占地面积(㎡)">
				</el-table-column>
				<el-table-column prop="usecatename" label="物业类型">
				</el-table-column>
<!-- 				
				<el-table-column prop="building_category" label="建筑类型">
				</el-table-column> -->
				<el-table-column prop="buildacreage" label="建筑面积(㎡)">
				</el-table-column>
				<el-table-column prop="volume" label="容积率">
				</el-table-column>
			
				<el-table-column prop="business_type" label="业态类型">
				</el-table-column>
				<el-table-column prop="main_house_type" label="主力户型">
				</el-table-column>
				<el-table-column prop="decoration" label="装修情况">
				</el-table-column>
				<el-table-column prop="parking_space" label="停车位">
				</el-table-column>
				<el-table-column prop="parking_space_ratio" label="车位配比">
				</el-table-column>
				<el-table-column prop="selling_price" label="在售价格(元/㎡)">
				</el-table-column>
			</el-table>

		</div>
	</div>
</template>

<script>

import VueBMap from "vue-bmap-gl";
import { getDetail, downloadFileByCate, loupanData } from "../../api/data";
let bmapManager = new VueBMap.BMapManager();

export default {
	name: 'FrontendPcBigdataLandlayout',
	components: { VueBMap },

	data() {
		return {
			id: 0,
			diyLabel: {
				position: []
			},
			map: {},
			detail: {},
			zoom: 15,
			imglist: [],
			center: [],
			events: {
				init: (o) => {
					var mapType1 = new BMapGL.MapTypeControl({ mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP] });
					o.addControl(mapType1);
					this.map = o
					var scaleCtrl = new BMapGL.ScaleControl();  // 添加比例尺控件
					this.map.addControl(scaleCtrl);
					var zoomCtrl = new BMapGL.ZoomControl();  // 添加缩放控件
					this.map.addControl(zoomCtrl);
				},
			},
			loupan_status: [1],
			listdata: []

		};
	},
	// computed: {
	// 	tableData: {
	// 		get() {
	// 			const data = this.$store.state.currentLandData
	// 			return [this.$store.state.currentLandData]

	// 		},
	// 		set(v) {
	// 			this.$store.commit('currentLandData', v)
	// 		}
	// 	}
	// },
	watch: {
		loupan_status: {
			handler(nv, ov) {
				if (nv.length === 0) {
					this.loupan_status = [1]
				} else {
					this.getDataBylnglat()
				}
			}
		},
		deep: true
	},
	mounted() {

		if (this.$route.params.id) {
			this.id = this.$route.params.id
		}
		this.getMapDetail().then(res => {
			this.drawPoint(this.detail)
			this.createOverlay(this.detail)
			this.getDataBylnglat()

		})


	},

	methods: {

		//根据经纬度获取数据
		getDataBylnglat() {
			const { sw, ne } = this.map.getBounds()
			const ru_lng = ne.lng
			const ru_lat = ne.lat
			const ll_lng = sw.lng
			const ll_lat = sw.lat
			const params = {
				ll_lng,
				ll_lat,
				ru_lng,
				ru_lat,
				loupan_status: this.loupan_status.toString(),
				id: this.id
			}


			loupanData(params).then(res => {
				this.listdata = res.data
			})
		},

		getImgList() {
			downloadFileByCate({ pid: this.id, category_id: 9 }).then(res => {
				console.log('imglist', res.data)
				this.imglist = res.data
			})

		},

		getMapDetail() {
			var that = this
			return new Promise(function (resolve, reject) {
				getDetail({ id: that.id }).then(res => {
					that.detail = res.data
					that.center = [
						res.data.lng,
						res.data.lat
					]
					that.diyLabel.position = [res.data.lng,
					res.data.lat]

					resolve(res.data)
				})

			})

		},
		//画点
		drawPoint(itemdata) {

			const type5 = require('@/assets/point.png')

			const myIcon = new BMapGL.Icon(type5, new BMapGL.Size(50, 110), {
				imageOffset: new BMapGL.Size(0, 0)   // 设置图片偏移   
			})

			// 创建标注对象并添加到地图  
			const marker = new BMapGL.Marker(new BMapGL.Point(parseFloat(itemdata.lng), parseFloat(itemdata.lat)), { icon: myIcon });
			marker.id = itemdata.id
			this.map.addOverlay(marker);
		},


		// 创建一个多变形
		createOverlay(data) {

			const allset = data.set
			const setObj = JSON.parse(allset)
			setObj.map(item => {
				// data 是一个多变形的数据
				// 画一个多变形的方法
				this.createPolygon(item, data.id)
			})


		},

		createPolygon(data, id) {
			const pointobj = data.lnglat.split(';')
			const pointArr = pointobj.map(point => {
				const lnglat = point.split(',')
				return new BMapGL.Point(lnglat[0], lnglat[1])
			})

			const polygonAttribute = {
				strokeWeight: 2,
				strokeOpacity: 0.5,
				strokeColor: '#28A7E1',
				fillColor: data.color,
				fillOpacity: 1
			}

			const overlay = new BMapGL.Polygon(pointArr, polygonAttribute)

			overlay.mode = 'polygon'
			overlay.color = data.color
			overlay.index = data.index

			if (this.index < data.index) { // 更新当前的index
				this.index = data.index
			}
			overlay.id = id

			this.map.addOverlay(overlay)

		},


	},
};
</script>

<style lang="scss" scoped>
.container3 {
	width: 100%;
	height: calc(100vh - 188px);
	color: #333;
	// background:Red;
	overflow-y: scroll;
	position: relative;

}

.cateloupan_status {
	span {
		font-weight: bold;
		font-size: 14px;
		margin-right: 10px;
		display: inline-block;
	}

	display: flex;
	position: absolute;
	top: 30px;
	right: 80px;
	z-index:200;
	background:#fff;
	border-radius: 5px;
	height:40px;
	padding:0 20px;
	justify-content: center;
	align-items: center;
}

.mapcontainer3 {
	display: flex;
	width: 98%;
	margin: 0 1%;
	height: calc(100vh - 308px);
	margin-top: 10px;

	.bmap-demo {
		flex: 1;
	}
}

.zhibiaotitle {
	width: 98%;
	margin-top: 5px;
	margin-left: 1%;
	height: 40px;
	background: #28A7E1;
	border-radius: 8px 8px 0px 0px;
	font-size: 20px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #FFFFFF;
	line-height: 40px;
}

.swipercontainer3 {
	height: 400px;
}

.tabledata {
	width: 98%;
	margin-left: 1%;
}





.labelbox {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;

	border-radius: 5px;

	.labelcontent {
		border: solid 1px #fff;
		background:  #fff;
		border-radius: 4px;
		color: #333;
		font-size: 14px;
		padding: 4px;
		display: flex;
		flex-direction: row;
		padding: 5px 10px;
		justify-content: space-between;
		align-items: center;
		box-shadow:0 0 10px #06C;

		.iconimg {
			height: 30px;
			width: 30px;
		}

		.labeltext {
			margin-left: 10px;
		}

		// mar
	}

	.labeldown {
		margin-left:15px;
		width: 0;
		height: 0;
		border-top: 10px solid  #fff;
		border-right: 10px solid transparent;
		border-left: 10px solid transparent;

	}
}

// .labelbox {
// 	display: flex;
// 	flex-direction: column;
// 	justify-content: center;
// 	align-items: center;

// 	.labelcontent {
// 		border: solid 1px #fff;
// 		background: #fff;
// 		border-radius: 4px;
// 		color: #333;
// 		border: solid 1px #ccc;
// 		font-weight: bold;
// 		font-size: 12px;
// 		padding: 4px;
// 		// mar
// 	}

// 	.labeldown {
// 		width: 0;
// 		height: 0;
// 		border-top: 10px solid #fff;
// 		border-right: 10px solid transparent;
// 		border-left: 10px solid transparent;

// 	}
// }
</style>